<template>
	<div class="loyalty-block__card">
		<div
			class="loyalty-block__card-header"
			style="background-color: rgb(231, 224, 208)"
		>
			<h3 class="loyalty-block__card-title">
				<span v-if="langEn" class="font-weight-bolder">
					Join the loyalty program
				</span>
				<span v-else class="font-weight-bolder">
					Присоединяйтесь к программе лояльности Школы
				</span>
			</h3>
		</div>

		<div class="loyalty-block__card-content">
			<div class="loyalty-block__awarded-points w-100 mw-100">
				<span v-if="langEn">Get 1000 points for registration <br> +</span>
				<span v-else>
					Вам будет начислено: <br>
					1 000 баллов за регистрацию <br> +
				</span>
				<span v-if="awardedPoints">
					<span v-if="langEn">
						{{ $points(awardedPoints) }} points
						<span v-if="awardedPoints">*</span> for your first purchase
					</span>
					<span v-else>
						{{ $points(awardedPoints) }} баллов
						<span v-if="awardedPoints">*</span> за покупку
					</span>
				</span>
				<span v-else-if="firstProgramThreshold && firstProgramThreshold.points">
					<span v-if="langEn">
						{{ $points(firstProgramThreshold.points) }}% of the first purchase price
					</span>
					<span v-else>
						{{ $points(firstProgramThreshold.points) }}% от стоимости первой покупки
					</span>
				</span>
			</div>
		</div>

		<div v-if="awardedPoints" class="loyalty-block__card-footer">
			<span v-if="langEn">
				*{{ $points(firstProgramThreshold.points) }}% of the first purchase price
			</span>
			<span v-else>
				*{{ $points(firstProgramThreshold.points) }}% от стоимости первой покупки
			</span>
			<div class="mt-2">
				<a v-if="langEn" href="/loyalty-system/" target="_blank">Learn more-></a>
				<a v-else href="/loyalty-system/" target="_blank">Подробнее</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		originalPrice: {
			type: Number,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			firstProgramThreshold: null,
		};
	},

	computed: {
		awardedPoints() {
			return this.firstProgramThreshold?.points && this.originalPrice
				? (this.firstProgramThreshold.points * this.originalPrice) / 100
				: null;
		},
		langEn() {
			return this.$i18n.locale === 'en';
		},
	},

	async mounted() {
		await this.getLoyaltyLevels();
	},

	methods: {
		async getLoyaltyLevels() {
			const { first_program_trigger_threshold: firstProgramThreshold } = await this.$api.getLoyaltyLevels();

			if (firstProgramThreshold) {
				this.firstProgramThreshold = firstProgramThreshold;
			}
		},
	},
};
</script>
